module.exports = __webpack_public_path__ + "static/media/Barmag 7a2.f1d2ab68.jpg";